import { useCouponStore } from './useCouponStore.js';
/**
 * Hook to check if the coupon store has been hydrated.
 *
 * This is useful to prevent rendering components that depend on the coupon store before it has been fully initialized.
 *
 * @returns boolean indicating if the coupon store has been hydrated
 */
export function useHasHydratedCouponStore() {
  const hasHydrated = useCouponStore(_temp);
  return hasHydrated;
}
function _temp(store) {
  return store._hasHydrated;
}